<script setup lang="ts">
type Props = {
  data: Record<string, unknown>
  theme: string | null | undefined
}

// SectionsText props
const _props = defineProps<Props>()
provide('showMediaCaption', true)
</script>

<template>
  <div class="px-bleed relative w-full overflow-clip">
    <div class="flex flex-col gap-5 lg:flex-row">
      <div class="lg:w-cols-6 flex w-full flex-col">
        <h2 v-if="data.title" class="text-label font-bold uppercase">{{ data.title }}</h2>
      </div>
      <div class="lg:w-cols-5 flex w-full flex-col">
        <ElementsPortableTextWrapper :content="data.content" />
      </div>
    </div>
  </div>
</template>
